import { toast } from "sonner";

import type { FinalizedPaymentStatus } from "@shyne/shared/api";

export type StripeFinalizeStatus = FinalizedPaymentStatus;

export function showStripeDueFinalizeToast(status: StripeFinalizeStatus) {
  if (status === "failed") {
    toast.error("Stripe payment failed. Dues remain unpaid.");
  } else if (status === "pending") {
    toast.info("Stripe payment is processing. Dues will be marked paid after Stripe confirms it.");
  } else {
    toast.success("Stripe payment recorded successfully.");
  }
}

export function showStripeExtraFinalizeToast(status: StripeFinalizeStatus) {
  if (status === "failed") {
    toast.error("Stripe payment failed. Extra payment was not recorded.");
  } else if (status === "pending") {
    toast.info("Extra payment is processing. It will be recorded after Stripe confirms it.");
  } else {
    toast.success("Extra payment recorded successfully.");
  }
}
